import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import axios from 'src/api/Api';
import {
    GET_SHIP_TO_ADDRESS_SUCCESS,
    GET_SHIP_TO_SEARCH_SUCCESS,
    GET_SHIP_TO_SEARCH_SUCCESS_TISSUE,
    GET_SHIP_TO_ADDRESS_FAILURE,
} from '../actions';
import { accountNumberZeroTrimmer, convertObjectToQueryParams } from 'src/utils/util';

export default function* getShipToAddress(action) { 
    // const sapPartnerId = yield select(
    //     (state) => state.equityReducer.equityDetails.accountId.accountId
    // );
    const { searchTerm, tissue } = action.payload;
    const isTissueService = tissue? true : false;
    const billToShipToPartnerRole = localStorage.getItem('billToShipToPartnerRole');
    const sapPartnerIdOtherUser = yield select(
        (state) => state.equityReducer.equityDetails.accountId.accountId
     );
    const sapPartnerIdJapanUser = yield select(
        (state) => state.equityReducer.equityDetails?.billToId?.billToNumber
    );
    const sapPartnerIdResult = () => {
        if(billToShipToPartnerRole == 'BILL_TO'){
            return sapPartnerIdJapanUser;
        }
        else 
        return sapPartnerIdOtherUser;
    };
     const sapPartnerId = sapPartnerIdResult();

    const selectedAccount = yield select((state) => state.replenishAccount);

    const objParams = {
        sapPartnerId:
            selectedAccount.selectedAccount !== undefined
                ? selectedAccount.selectedAccount.accountId
                : sapPartnerId,
        searchTerm: searchTerm??'',
        orderType: 'ZOR'
    };

    const isFalsyValueRequired = false;

    // const url = `occ/v2/${localStorage.getItem(
    //     'baseSiteId'
    // )}/order/surgery/shiptoaddress?sapPartnerId=${selectedAccount.selectedAccount!==undefined ? selectedAccount.selectedAccount.accountId :sapPartnerId}`;

    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/shiptoaddress?${convertObjectToQueryParams(
        objParams,
        isFalsyValueRequired
    )}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        const updatedResult =  { ...result,
            shipToData: {
                ...result.shipToData,
                nonTissueAddress: result.shipToData?.nonTissueAddress?.map((item) => {
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                }),
                tissueAddress: result.shipToData?.tissueAddress?.map((item)=>{
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                })
            },
        } ;
        if(action.payload.searchTerm && isTissueService){
            yield put({ 
                type: GET_SHIP_TO_SEARCH_SUCCESS_TISSUE,
                payload: updatedResult.shipToData || [],
                statusCode: updatedResult.statusCode,
                statusMessage: updatedResult.statusMessage,
                loading:false
            });
        }
        else if(action.payload.searchTerm && !isTissueService){
            yield put({ 
                type: GET_SHIP_TO_SEARCH_SUCCESS,
                payload: updatedResult.shipToData || [],
                statusCode: updatedResult.statusCode,
                statusMessage: updatedResult.statusMessage,
                loading:false
            });
        }
        else if(!action.payload.searchTerm){
            yield put({
                type: GET_SHIP_TO_ADDRESS_SUCCESS,
                payload: updatedResult.shipToData || [],
                statusCode: updatedResult.statusCode,
                statusMessage: updatedResult.statusMessage,
                loading:false
            });
            yield put({
                type: GET_SHIP_TO_SEARCH_SUCCESS,
                payload: updatedResult.shipToData || [],
                statusCode: updatedResult.statusCode,
                statusMessage: updatedResult.statusMessage,
                loading:false
            });
            yield put({ 
                type: GET_SHIP_TO_SEARCH_SUCCESS_TISSUE,
                payload: updatedResult.shipToData || [],
                statusCode: updatedResult.statusCode,
                statusMessage: updatedResult.statusMessage,
                loading:false
            });
        } 
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_SHIP_TO_ADDRESS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
            loading:false
        });
    }
}
